import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  QueryList,
  ViewChildren
} from '@angular/core';

import { LoginService } from '../../services/login.service';
import { StringTableService } from '../../services/string-table.service';
import { BaseComponent } from '../base/base.component';

@Component({
  selector: 'app-main-navbar',
  templateUrl: './main-navbar.component.html',
  styleUrls: ['./main-navbar.component.scss']
})
export class MainNavbarComponent extends BaseComponent implements OnInit, AfterViewInit {

  public menuItems: Array<{ name: string }>;
  public menuItemsReview: Array<{ name: string }>;

  /**
   * stores the references to the HTMLListElement - the menu list
   * @private
   * @memberof NavbarComponent
   */
  private referenceToMenu: any = [];

  /**
   *
   * Stores the name of the currently highlighted menu item
   * @memberof MainNavbarComponent
   */
  @Input() selectedIndex: number;

  @Input() adminClientId: string;

  @Output() clicked: EventEmitter<object> = new EventEmitter();
  @Output() selectedTabChanged: EventEmitter<any> = new EventEmitter();

  @ViewChildren('menuItemElements') private menuItemElements: QueryList<ElementRef>;

  constructor(
    public elementRef: ElementRef,
    private stringTableService: StringTableService,
    private loginService: LoginService
  ) {
    super(elementRef);
    this.selectedIndex = 0;
    this.menuItems = (this.stringTableService.getArrayOfStrings('mainNavbar', 'content') as any);
    this.menuItemsReview = (this.stringTableService.getArrayOfStrings('reviewNavbar', 'content') as any);
  }

  ngOnInit() {
    if (this.adminClientId !== '0') {
      let indexOfSuperAdmin: number;
      this.menuItems.forEach((item, index) => {
        if (item.name === 'Super Admin') {
          indexOfSuperAdmin = index;
          return;
        }
      });

      if (indexOfSuperAdmin) {
        this.menuItems.splice(indexOfSuperAdmin, 1);
      }

    }
  }

  ngAfterViewInit() {
    this.menuItemElements.forEach(this.handleAddingOfMenuList.bind(this));
  }

  private handleAddingOfMenuList(listMenuElement: ElementRef) {
    const menuName = listMenuElement.nativeElement.innerText.trim();
    this.referenceToMenu[menuName] = listMenuElement;
  }

  private changeActive(newActive) {
    if (newActive === 4) {
      return;
    }
    this.selectedIndex = newActive;
    this.clicked.emit({ index: newActive, event: 'selected' });
    this.selectedTabChanged.emit();
  }

}



// WEBPACK FOOTER //
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/components/main-navbar/main-navbar.component.ts